import React from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-responsive-modal";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import { getlanguagelist } from "../../../helpers/changelanguage";

 

const customStyles = {
    width: '556px',
    position: 'relative'
  };
const PaymentOption = (props) => {
  const { paymentoptmodal } = props;
  
  function closeModal(){
    props.onPaymentoptmodelClose();
  }

  const onSubmit = (option) => {
    props.onPaymentoptSubmit(option);
  }
  
  let  languagelist = getlanguagelist();
 
    return (
     
       
        <Modal open={paymentoptmodal} onClose={closeModal} showCloseIcon={false} center>
          
       
          <div className="modal-header2">
            <button type="button" className="close" onClick={closeModal} ><img src="/assets/images/close_btn.png"/></button>
            
          </div>
          <div className="modal-body" style={customStyles}>
          
          
             
                <div className="row" >
                <center>
                   <input type="button" className="otp_btn" value={languagelist.payoptn2} onClick={()=>onSubmit('PAYPAL')}/>
                   &nbsp; &nbsp;
                   <input type="button" className="otp_btn" value={languagelist.payoptn1} onClick={()=>onSubmit('EVC_WALLET')}/>
                </center>  
                </div>
                
             
            
          </div>
          
          
        

      </Modal>
    
    );
}
export default PaymentOption;